module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Born in Felixstowe, Franky moved to North Suffolk as a small child. She still lives close to the Norfolk/Suffolk border with her husband, John, and their dog.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Franky trained as a shorthand/typist/secretary and worked as such in a variety of industries, including a rock and sweet making factory, an offshore oil and gas platform construction company and as a local government officer. Other employment include music engraving and over two decades as a parish council clerk.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Her hobbies include music – she plays tenor recorder, guitar, piano and church organ, and the last of these led to her becoming the chapel organist for twenty years in a local prison.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Her other interests are artistic roller skating – she is a member of the Waveney Roller Skating Club; dressmaking, walking her dog in the countryside and reading.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("This is Franky’s first novel and also the first in "), _c('em', [_vm._v("The PepperAsh")]), _vm._v(" series.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("If you would like to know more about Franky and to follow her on Facebook, please go to ‘Franky Sayer Author’.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0